<template>
  <div class="Home_Carousel">
    <swiper
      :modules="modules"
      :pagination="{ clickable: true }"
      :autoplay="{ delay: 3000, disableOnInteraction: false }"
      :loop="true"
      class="mySwiper"
    >
      <swiper-slide v-for="(slide, index) in slides" :key="index">
        <div class="Home_Carousel">
          <div class="Home_Carousel_text_wrapper">
            <!-- <h1>{{ $t(slide?.title) }}</h1> -->
            <!-- <p>{{ $t(slide?.description1) }}</p> -->
          </div>
          <div class="Home_Carousel_img_wrapper" >
            <img :src="slide.img" alt="slide" loading="lazy" />

          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
  
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper/modules";

// import Slide1 from "@/assets/Images/home_img/slide1.svg"
// import Slide2 from "@/assets/Images/home_img/slide2.svg"
// import Slide3 from "@/assets/Images/algoritim_result/hackaton.jpg"
import Slide1 from "@/assets/Images/algoritim_result/sertificate.jpg"
// import Slide2 from "@/assets/Images/algoritim_result/kids.jpg"
import Slide2 from "@/assets/Images/algoritim_result/sert.jpg"
import Slide3 from "@/assets/Images/algoritim_result/tour.jpg"
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const slides = [
      {
        title: "hero__title",
        description1:
          "hero__description",
        img: Slide1,
      },
       {
        title: "hero__title2",
        description1:       
          "hero__description2",
        img: Slide2,
      },
       {
        title: "hero__title3",
        description1:
          "hero__description3",
        img: Slide3,
      },
      //  {
      //   title: "hero__title4",
      //   description1:
      //     "hero__description4",
      //   img: Slide4,
      // },
  
    ];

    return {
      modules: [Pagination, Autoplay],
      slides,
    };
  },
};
</script>

<style>
.Home_Carousel {
  width: 100%;
  height: 411px;
  border-radius: 10px;
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-top: 20px;
}
.mySwiper {
  width: 100%;
  height: 100%;
  margin-top: 20px;
}
.Home_Carousel_text_wrapper {
  width: 55%;
  height: auto;
  padding: 35px 50px;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  align-self: flex-start;
  align-content: flex-end;
}
.Home_Carousel_text_wrapper h1 {
  color: white;
  font-size: 56px;
  line-height: 58px;
  font-weight: 700;
  font-family: Nohemi;
  letter-spacing: 2px;
}

.Home_Carousel_text_wrapper p:nth-of-type(1) {
  width: 586px;
  line-height: 100%;
  font-size: 17px;
  font-family: Nohemi;
  font-weight: 300;
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.7);
}
.Home_Carousel_text_wrapper p:nth-of-type(2) {
  width: 586px;
  line-height: 100%;
  font-size: 17px;
  font-weight: 300;
  font-family: Nohemi;
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.7);
}

.Home_Carousel_img_wrapper {
  display: flex;
  align-items: center;
  width:100%;
  height: 100%;
  position: absolute;
  background-color: rgba(11, 11, 11);
  
}

.Home_Carousel_img_wrapper img{
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 10px;

  object-fit: cover;

  filter: brightness(100%);
  z-index: 1;
}



.swiper-pagination-bullet {
  background-color: rgb(45, 44, 44); 
  width: 45px;
  height: 4px;
  opacity: 1;
  border-radius: 3px;
  position: relative;
  overflow: hidden;
}

.swiper-pagination-bullet-active {
  background-color: rgb(45, 44, 44); 
  position: relative;
}

.swiper-pagination-bullet-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 0%;
  height: 100%;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  animation: fillProgress 3s linear forwards; 
}

@keyframes fillProgress {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
.swiper-pagination {
  display: flex;
  justify-content: flex-start;
  padding-left: 50px;
  margin-bottom: 40px;
}
@media (max-width: 1440px) {
  
 
  
}
@media (max-width: 1240px){
  .Home_Carousel_text_wrapper {
    width: 100%;
    padding: 20px;
  }
  .Home_Carousel{
    flex-direction: column;
  }
  .Home_Carousel_img_wrapper {
    width: 100%;
    height: 300px;
  }
  
  .Home_Carousel_text_wrapper h1 {
    font-size: 36px;
    line-height: 40px;
  }
 
}
@media (max-width: 768px) {
  .Home_Carousel {
    height: auto;
    flex-direction: column;
    align-items: center;
    min-height: 400px;
    padding: 0px 0px 30px 0px;
  }
  .mySwiper {
    height: auto;
  }
  .swiper-pagination {
    padding-left: 0px;
    margin-bottom: 20px;
  }
  .Home_Carousel_text_wrapper {
    width: 100%;
    padding: 20px;
  }
  .Home_Carousel_text_wrapper h1 {
    font-size: 36px;
    line-height: 40px;
  }
  .Home_Carousel_text_wrapper p:nth-of-type(1) {
  width: 100%;
  line-height: 100%;
  
  } 
 
}
@media (max-width: 500px) {
  .Home_Carousel_text_wrapper h1 {
    font-size: 28px;
    line-height: 30px;
  }

   .Home_Carousel_text_wrapper > img {
    width: 150px;
    font-size: 13px;
    
  }
  .Home_Carousel_text_wrapper p:nth-of-type(1) {
  width: 100%;
  line-height: 100%;
  
  } 
  
  
 
}
</style>
